<div class="header" *ngIf="idea.comments.length > 0">
  <p *ngIf="!standalone"><strong>Comments:</strong></p>
  <h3 *ngIf="standalone">Comments</h3>
  <span (click)="scrollOnePageUp()" [ngClass]="{ active: scrollable }">
    See earlier comments
  </span>
  <br *ngIf="standalone" />
</div>

<ul
  class="comment-list"
  #commentlist
  (scroll)="adoptHeight()"
  [ngClass]="{ 'limited-height': standalone }">
  <ng-container *ngFor="let comment of rootComments">
    <li
      *ngIf="
        participantDict[comment.created_by] &&
        participantDict[comment.created_by].user
      ">
      <comment
        [comment]="comment"
        [idea]="idea"
        [session]="session"
        [focusedComment]="focusedComment"
        (focusRequest)="scrollToComment($event)"
        (reply)="reply($event)"></comment>
    </li>
  </ng-container>
  <li *ngIf="!idea.comments.length">No comments, yet.</li>
</ul>

<div class="form-group mb-3">
  <label class="form-label" for="comment" *ngIf="!comment.parent">
    Comment:
  </label>
  <div class="reply-preview" *ngIf="comment.parent">
    <div class="top">
      <label class="form-label" for="comment">Reply To:</label>
      <button
        class="btn btn-sm fa fa-times"
        title="Cancel reply"
        (click)="cancelReply()"></button>
    </div>
    <comment
      [idea]="idea"
      [session]="session"
      [comment]="comment.parent"
      [preview]="true"
      (click)="
        (focusedForReply = true) && focusComment(comment.parent)
      "></comment>
  </div>
  <div mwlTextInputHighlightContainer>
    <textarea
      #textarea
      class="form-control"
      [ngClass]="{ animate: feedbackGenerationInProgress }"
      rows="2"
      id="comment"
      name="comment"
      [(ngModel)]="comment.text"
      (ngModelChange)="emitDraft()"
      maxlength="{{ inputLengths.COMMENT }}"
      [mentionConfig]="mentionConfig"
      mwlTextInputElement
      (input)="highlightMentions()"></textarea>
    <!-- TODO: find replacement -->
    <!-- <mwl-text-input-highlight
        [tags]="mentionHighlights"
        [textInputElement]="textarea">
      </mwl-text-input-highlight> -->
  </div>
</div>
<div class="actions" [ngClass]="{ standalone: standalone }">
  <button
    class="btn btn-primary"
    (click)="postComment()"
    *ngIf="!comment.parent">
    Send Comment
  </button>
  <button
    class="btn btn-primary"
    (click)="postComment()"
    *ngIf="comment.parent">
    Reply
  </button>
  <button class="btn" (click)="cancelReply()" *ngIf="comment.parent">
    Cancel
  </button>
  <groupchat-button
    *ngIf="!standalone"
    [session]="session"
    [idea]="idea"
    label="Discuss with Collaborators"></groupchat-button>
  <button
    style="margin-left: 8px"
    [ngClass]="{ disabled: feedbackGenerationInProgress }"
    *ngIf="session.config.enable_automatic_feedback_generation"
    class="btn"
    (click)="!feedbackGenerationInProgress && generateFeedback()">
    Leo's opinion
  </button>
</div>
